<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0.75C3.99594 0.75 0.75 3.99594 0.75 8C0.75 12.0041 3.99594 15.25 8 15.25C12.0041 15.25 15.25 12.0041 15.25 8C15.25 3.99594 12.0041 0.75 8 0.75Z"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'RadioOff'
};
</script>

<style scoped>
svg path {
  stroke: currentColor;
  fill: white;
}
</style>
